<template>
  <label class="label" :for="props.for" :disabled="props.disabled">
    <slot />
  </label>
</template>


<script setup>

const props = defineProps({
  disabled:    { type: [Boolean,String],  default: false },
  for:         { type: String,            default: null },
});

</script>
